import { Boton } from '@/componentes/Boton'
import { useSesion } from '@/datos/sesion'
import { es } from '@/textos/es'
import { LayoutAcceso } from './LayoutAcceso'

export function SinAcceso() {
  const { salir } = useSesion()
  return (
    <LayoutAcceso>
      <div className="flex flex-col gap-4">
        <h2 className="text-h1">{es.acceso.sinAccesoTitulo}</h2>
        <p className="text-body text-tinta-2">{es.acceso.sinAccesoTexto}</p>
        <Boton variante="neutro" onClick={() => void salir()}>
          {es.acceso.salir}
        </Boton>
      </div>
    </LayoutAcceso>
  )
}
